// Default LaunchDarkly user context
export const defaultUser = Object.freeze({
  kind: 'user',
  key: 'eng-internal',
  email: 'engineering@dutchie.com',
  type: 'default-user', // will be overridden by the user's actual type as needed
});
